<template>
	<div>
		<div class="page-filter-box">
			<el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-input v-model="params.queryValue" class="input-with-select" size="small">
						<el-select v-model="params.queryKey" slot="prepend" placeholder="请选择">
							<el-option label="演出ID" :value="1"></el-option>
							<el-option label="演出名称" :value="2"></el-option>
							<el-option label="项目负责人" :value="3"></el-option>
							<el-option label="结款方ID" :value="4"></el-option>
							<el-option label="结款方名称" :value="5"></el-option>
							<el-option label="合同编号" :value="6"></el-option>
							<el-option label="账户名" :value="7"></el-option>
						</el-select>
					</el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<!-- <el-select v-model="params.showTypeTagId" placeholder="请选择" size="small">
                        <el-option label="不限制活动类型" value=""></el-option>
                        <el-option v-for="(item, index) in showTypeTagList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select> -->
					<el-cascader clearable v-model="params.showTypeTagId" :options="showTypeTagList"
						:props="{value:'id',label:'name',children:'tags', emitPath:false}" placeholder="不限制活动类型"
						size="small" style="width:100%"></el-cascader>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.activityChannel" placeholder="不限制演出来源" class="fl fl-big-select" clearable
						size="small">
						<el-option label="不限制演出来源" value=""></el-option>
						<el-option v-for="(item, index) in activityChannel" :label="item.value" :key="index"
							:value="item.key"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.siteTypeTagId" placeholder="请选择" size="small">
						<el-option label="不限制场地类型" value=""></el-option>
						<el-option v-for="(item, index) in siteTypeTagList" :key="index" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.sellIdentity" placeholder="请选择" size="small">
						<el-option label="不限制售票模式" :value="0"></el-option>
						<el-option label="仅看独家的" :value="1"></el-option>
						<el-option label="仅看多平台的" :value="2"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.status" placeholder="请选择" size="small">
						<el-option label="不限制演出状态" :value="-1"></el-option>
						<el-option label="仅看预售中的" :value="2"></el-option>
						<el-option label="仅看已结束的" :value="3"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.specialSettlement" multiple collapse-tags placeholder="请选择异常结款场景"
						size="small" style="width:100%">
						<el-option label="涉及结款分账的" :value="1"></el-option>
						<el-option label="有过二次退款的" :value="2"></el-option>
						<el-option label="涉及线下分销结款的" :value="3"></el-option>
						<el-option label="第三方服务费秀动承担的" :value="4"></el-option>
						<el-option label="有额外费用需要票款抵扣的" :value="5"></el-option>
					</el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.isApplySettlement" placeholder="请选择" size="small">
                        <el-option label="不限制结款申请状态" :value="-1"></el-option>
                        <el-option label="仅看有过申请的" :value="1"></el-option>
                        <el-option label="仅看没有申请的" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.isBalance" placeholder="请选择" size="small">
                        <el-option label="不限制结款状态" :value="-1"></el-option>
                        <el-option label="仅看未结款的" :value="0"></el-option>
                        <el-option label="仅看部分结款的" :value="1"></el-option>
                        <el-option label="仅看已结款的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.balanceType" placeholder="请选择" size="small">
                        <el-option label="不限制结算方式" :value="0"></el-option>
                        <el-option label="仅看预付款的" :value="1"></el-option>
                        <el-option label="仅看后付款的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.isNormalBalance" placeholder="请选择" size="small">
                        <el-option label="不限制是否正常结款" :value="-1"></el-option>
                        <el-option label="仅看正常结款的" :value="1"></el-option>
                        <el-option label="仅看暂停结款的" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.queryTimeKey" slot="prepend" placeholder="请选择">
                                <el-option label="演出结束时间" :value="1"></el-option>
                                <el-option label="结款申请时间" :value="2"></el-option>
                                <el-option label="打款时间" :value="3"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/activityFinanceSettle/exportInfo')"  type="primary" icon="el-icon-download" size="small" @click="download1" :loading="downLoading1">导出费用明细</el-button>
            <el-button v-if="$utils.have('/activityFinanceSettle/exportReceivables')"  type="primary" icon="el-icon-download" size="small" @click="download2" :loading="downLoading2">导出结款信息</el-button>
            <!-- <el-button v-if="$utils.have('/activityFinanceSettle/batchReceivables')"  type="primary" icon="el-icon-tickets" size="small" @click="$refs.batch.show()">批量结款</el-button> 6257345950去掉该功能 -->
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="演出ID"></el-table-column>
                <el-table-column prop="title" label="演出名称" min-width="250" show-overflow-tooltip></el-table-column>
                <el-table-column prop="showTypeTagName" label="活动类型"></el-table-column>
                <el-table-column prop="siteTypeTagName" label="场地类型"></el-table-column>
                <el-table-column prop="principalName" label="项目负责人" min-width="90" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sellIdentity" label="售票模式">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sellIdentity == 1">独家</span>
                        <span v-else-if="scope.row.sellIdentity == 2">多平台</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="演出状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 2" class="color-success">预售中</span>
                        <span v-else-if="scope.row.status == 3">已结束</span>
                    </template>
                </el-table-column>
                <el-table-column prop="saleTicketNum" label="销售票数"></el-table-column>
                <el-table-column  label="销售金额" min-width="140" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>票品金额：{{scope.row.saleAmountFormat}}</p>
						<p>乐迷服务费：{{scope.row.userServiceFeeFormat}}</p>
					</template>
				</el-table-column>
				<el-table-column label="优惠" min-width="150">
					<template slot-scope="scope">
						<p>秀动承担优惠：{{scope.row.platDiscountFormat}}</p>
						<p>B类承担优惠：{{scope.row.busDiscountFormat}}</p>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="consignRefundFeeStr" label="托售乐迷服务费" min-width="120"></el-table-column>
                <el-table-column prop="serviceFeeType" label="收费方式" min-width="130"></el-table-column> -->
				<el-table-column label="实际收入" min-width="140" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>票品金额：{{scope.row.amountFormat}}</p>
						<p>乐迷服务费：{{scope.row.userServiceFeeFormat}}</p>
					</template>
				</el-table-column>
				<el-table-column label="秀动B类服务费" min-width="140" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>收费方式：<span v-if="scope.row.serviceFeeType == 0">不收取</span>
							<span v-else-if="scope.row.serviceFeeType == 1">固定金额</span>
							<span v-else-if="scope.row.serviceFeeType == 2">按比例收取({{scope.row.serviceFee}}%)</span>
						</p>
						<p>服务费用：{{scope.row.serviceFeeAmountFormat}}</p>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="serviceFeeType" label="收费方式" min-width="130">
                    <template slot-scope="scope">
                        <span v-if="scope.row.serviceFeeType == 0">不收取</span>
                        <span v-else-if="scope.row.serviceFeeType == 1">固定金额</span>
                        <span v-else-if="scope.row.serviceFeeType == 2">按比例收取({{scope.row.serviceFee}}%)</span>
                    </template>
                </el-table-column>
                <el-table-column prop="serviceFeeAmountFormat" label="服务费用"></el-table-column> -->
				<el-table-column label="退票手续费" min-width="140" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-popover placement="right" width="300" trigger="hover">
							<div>公式：扣除乐迷 - 秀动保留 = 结给B类</div>
							<div slot="reference" class="hand">{{scope.row.refundFeeStr}} -
								{{scope.row.xdRetainRefundFeeStr}} = {{scope.row.settleRefundFeeStr}}<span
									class="el-icon-question color-success ML5"></span></div>
						</el-popover>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="refundFeeStr" label="扣除乐迷手续费" min-width="120"></el-table-column>
				<el-table-column prop="xdRetainRefundFeeStr" label="秀动保留手续费" min-width="120"></el-table-column>
				<el-table-column prop="settleRefundFeeStr" label="结给主办手续费" min-width="120"></el-table-column> -->


				<el-table-column prop="playPriceTicketFormat" label="实际打款金额" min-width="100"></el-table-column>

				<el-table-column label="时间" min-width="200" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>最近申请：{{scope.row.createTime}}</p>
						<p>最近打款：{{scope.row.playTime}}</p>
					</template>
				</el-table-column>

				<!-- <el-table-column prop="createTime" label="结款申请时间" min-width="150"></el-table-column>
                <el-table-column prop="playTime" label="打款时间" min-width="150"></el-table-column> -->
				<el-table-column prop="lastSessionEndTime" label="演出起止时间" min-width="180">
					<template slot-scope="scope">
						<p>起: {{scope.row.firstSessionStartTime}}</p>
						<p>止: {{scope.row.lastSessionEndTime}}</p>
					</template>
				</el-table-column>
				<el-table-column label="结款状态" min-width="130" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>申请状态: {{scope.row.applySettlementStatusView}}</p>
						<p>结款状态: {{scope.row.balanceStatusView}}</p>
					</template>
				</el-table-column>

				<!-- <el-table-column prop="isApplySettlement" label="结款申请状态" min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isApplySettlement == 0">未申请</span>
                        <span v-else-if="scope.row.isApplySettlement == 1">已申请</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isBalance" label="结款状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isBalance == 0">不可结款</span>
                        <span v-else-if="scope.row.isBalance == 1">未结款</span>
                        <span v-else-if="scope.row.isBalance == 2">已结款</span>
                    </template>
                </el-table-column> -->
				<el-table-column prop="balanceType" label="结算方式">
					<template slot-scope="scope">
						<!-- <span v-if="scope.row.balanceType == 1">预付款</span> -->
						<el-popover v-if="scope.row.balanceType == 1" trigger="click">
							<div class="popover-content">
								<el-row :gutter="30">
									<el-col :span="8">
										<b>￥{{scope.row.investAmount || 0}}</b>
										<p class="color-info">投资金额</p>
									</el-col>
									<el-col :span="8">
										<b>￥{{scope.row.saleAmountFormat || 0}}</b>
										<p class="color-info">销售金额</p>
									</el-col>
									<el-col :span="8">
										<b>{{scope.row.divideProportion || 0}}%</b>
										<p class="color-info">秀动所占分成比例</p>
									</el-col>
								</el-row>
								<el-row :gutter="30" class="MT20">
									<el-col :span="12">
										<b>{{scope.row.huiKuanRate || 0}}%</b>
										<p class="color-info">回款率（销售金额/投资金额）</p>
									</el-col>
									<el-col :span="12">
										<b>￥{{scope.row.totalProfit || 0}}</b>
										<p class="color-info">总利润（销售金额-投资金额）</p>
									</el-col>
									<!-- <el-col :span="8">
                                        <b>￥{{scope.row.profitAndLoss || 0}}</b>
                                        <p class="color-info">秀动盈亏（总利润*秀动所占分成比例）</p>
                                    </el-col> -->
								</el-row>
							</div>
							<el-button style="text-decoration:underline;" slot="reference" type="text"
								size="mini">预付款</el-button>
						</el-popover>

						<span v-else-if="scope.row.balanceType == 2">后付款</span>
					</template>
				</el-table-column>
				<el-table-column prop="receivablesUserType" label="结款方" width="180" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>身份:
							{{$userType.get(scope.row.receivablesUserType)}}
						</p>
						<p>名称:
							{{scope.row.receivablesUserName}}（ID:{{scope.row.receivablesUserId}}）
						</p>
					</template>
				</el-table-column>
				<el-table-column prop="contractSn" label="合同编号" min-width="130"></el-table-column>
				<!-- <el-table-column prop="receivablesUserType" label="结款方身份" min-width="90">
                    <template slot-scope="scope">
                        {{$userType.get(scope.row.receivablesUserType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="receivablesUserId" label="结款方ID"></el-table-column>
                <el-table-column prop="receivablesUserName" label="结款方名称" min-width="90" show-overflow-tooltip></el-table-column> -->



				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<el-button v-if="$utils.have('/activityFinanceSettle/receivablesInfo')" type="text" size="small"
							icon="el-icon-tickets" @click="$refs.dataView.show(scope.row)">结款信息</el-button>
						<el-button v-if="scope.row.canSubmit === true" type="text" size="small" icon="el-icon-tickets"
							@click="view(scope.row)">生成结款单</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div v-if="data" class="page-pagination-box">
			<el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
				:current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
				layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
			</el-pagination>
		</div>
		<DataView ref="dataView" @onUpdate="getDataList"></DataView>
		<ViewDetail ref="viewDetail" @onUpdate="getDataList"></ViewDetail>
		<el-dialog title="导出费用明细提醒" :visible.sync="dialogVisible1" width="40%"
			v-if="downloadTips1 && downloadTips1 !=''" @close="dialogVisible1=false;downLoading1 = false">
			<div class="dialog-content">
				<p class="color-warning MB20"><span class="el-icon-warning"></span> 你提交的导出任务，存在以下特殊情况，请针对这些特殊情况走单独的流程处理
				</p>
				<div v-if="downloadTips1 && Object.keys(downloadTips1).length" class="tips-main">
					<div v-for="(items, key) in downloadTips1" :key="key" class="tip-card">
						<div class="tip-header">
							{{ key }}
						</div>
						<ul class="tip-list">
							<li v-for="(item, index) in items" :key="index">
								{{ item }}
							</li>
						</ul>
					</div>
				</div>
				<div>
					<el-button type="primary" size="mini" icon="el-icon-document-copy"
						@click="copy1">复制异常提醒内容</el-button>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible1=false;downLoading1 = false">先不导出</el-button>
				<el-button type="primary" @click="doExport1(false)">我知道了，继续导出</el-button>
			</span>
		</el-dialog>
		<el-dialog title="异常结款单提醒" :visible.sync="dialogVisible2" width="40%" v-if="downloadTips2 && downloadTips2 !=''"
			@close="dialogVisible2=false;downLoading2 = false;">
			<div class="dialog-content">
				<p class="color-warning MB20"><span class="el-icon-warning"></span> 你提交的导出任务，存在以下特殊情况，请针对这些特殊情况走单独的流程处理
				</p>
				<div v-if="downloadTips2 && Object.keys(downloadTips2).length" class="tips-main">
					<div v-for="(items, key) in downloadTips2" :key="key" class="tip-card">
						<div class="tip-header">
							{{ key }}
						</div>
						<ul class="tip-list">
							<li v-for="(item, index) in items" :key="index">
								{{ item }}
							</li>
						</ul>
					</div>
				</div>
				<div>
					<el-button type="primary" size="mini" icon="el-icon-document-copy"
						@click="copy2">复制异常提醒内容</el-button>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible2=false;downLoading2 = false;">先不导出</el-button>
				<el-button type="primary" @click="doExport2(false)">我知道了，继续导出</el-button>
			</span>
		</el-dialog>
		<input class="copyTool" ref="copyTool1" :value="JSON.stringify(downloadTips1)" />
		<input class="copyTool" ref="copyTool2" :value="JSON.stringify(downloadTips2)" />
	</div>
</template>
<script>
	import DataView from './components/dataView';
	import ViewDetail from './components/viewDetail';
	//import Batch from './components/batch';
	// import {downloadFileTmp} from '@/assets/js/commonApi.js';
	const defaultParams = {
		pageNo: 1,
		queryKey: 1,
		queryValue: '',
		queryTimeKey: 1,
		queryTimeStart: '',
		queryTimeEnd: '',
		// type: 0,
		sellIdentity: 0,
		status: -1,
		isApplySettlement: -1,
		balanceType: 0,
		isBalance: -1,
		showTypeTagId: "",
		siteTypeTagId: "",
		activityChannel: '',
		isNormalBalance: 1,
		specialSettlement: []
	}
	export default {
		components: {
			DataView,
			ViewDetail
		},
		data() {
			return {
				data: null,
				dataList: null,
				params: {
					...defaultParams,
					pageNo: parseInt(this.$route.query.pageNo || 1),
					pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
					queryKey: parseInt(this.$route.query.queryKey || 1),
					queryValue: this.$route.query.queryValue || '',
					queryTimeKey: parseInt(this.$route.query.queryTimeKey || 1),
					queryTimeStart: this.$route.query.queryTimeStart || '',
					queryTimeEnd: this.$route.query.queryTimeEnd || '',
					// type: parseInt(this.$route.query.type || 0),
					sellIdentity: parseInt(this.$route.query.sellIdentity || 0),
					status: parseInt(this.$route.query.status || -1),
					isApplySettlement: parseInt(this.$route.query.isApplySettlement || -1),
					balanceType: parseInt(this.$route.query.balanceType || 0),
					isBalance: parseInt(this.$route.query.isBalance || -1),
					showTypeTagId: parseInt(this.$route.query.showTypeTagId) || "",
					siteTypeTagId: parseInt(this.$route.query.siteTypeTagId) || "",
					isNormalBalance: parseInt(this.$route.query.isNormalBalance || 1),
					specialSettlement: this.$route.query.specialSettlement || [],
				},
				datetimerange: [this.$route.query.queryTimeStart || '', this.$route.query.queryTimeEnd || ''],
				listLoading: true,
				downLoading1: false,
				downLoading2: false,
				showTypeTagList: [],
				siteTypeTagList: [],
				activityChannel: [],
				dialogVisible1: false,
				downloadTips1: "",
				dialogVisible2: false,
				downloadTips2: "",
				copyTimer: null,
				copyTimer2: null,
			}
		},
		mounted() {
			this.getShowTypeTag();
			this.getSiteTypeTag();
			this.getDataList();
			this.getChannel()
		},
		methods: {
			//获取活动类型
			getShowTypeTag() {
				this.$request({
					url: "/styleTag/showType/all",
					method: "post",
					params: {
						isAll: 1
					}
				}).then(res => {
					const {
						state,
						result
					} = res.data;
					if (state == 1) {
						this.showTypeTagList = result || []
					}
				})
			},
			//获取场地类型
			getSiteTypeTag() {
				this.$request({
					url: "/styleTag/showType/site/all",
					method: "post",
					params: {
						isAll: 1
					}
				}).then(res => {
					const {
						state,
						result
					} = res.data;
					if (state == 1) {
						this.siteTypeTagList = result || []
					}
				})
			},
			//获取演出渠道
			getChannel() {
				this.$request({
					url: "/common/activitySource",
					method: "post",

				}).then(res => {
					const {
						state,
						result
					} = res.data;
					if (state == 1) {
						this.activityChannel = result || []
					}
				})
			},
			//获取列表
			getDataList() {
				this.listLoading = true;
				this.params = {
					...this.params,
					queryTimeStart: this.datetimerange && this.datetimerange[0] || '',
					queryTimeEnd: this.datetimerange && this.datetimerange[1] || ''
				}
				this.$request({
						url: "/activityFinanceSettle/list",
						method: "POST",
						data: this.params,
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = result;
							this.dataList = result.result || [];
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			//选择pageSize
			handleSizeChange(e) {
				this.params.pageNo = 1;
				this.params.pageSize = e;
				this.getDataList();
			},
			//搜索
			search() {
				this.params.pageNo = 1;
				this.getDataList();
			},
			//重置搜索
			reset() {
				this.datetimerange = [];
				this.params = {
					...defaultParams,
					pageSize: this.params.pageSize,
					specialSettlement: []
				};
				this.getDataList();
			},
			//导出费用明细
			async download1() {
				// let filePath;
				this.downLoading1 = true;
				try {
					const res = await this.$request({
						url: '/activityFinanceSettle/exportInfo',
						method: 'post',
						data: {
							...this.params,
							check: true
						}
					})
					const {
						state,
						msg,
						result
					} = res.data;
					if (state != 1) {
						this.$message.error(msg || '导出失败');
						this.downLoading1 = false;
						return;
					}
					if (result.needTips == true) {
						this.downloadTips1 = result.tips
						this.dialogVisible1 = true
					} else {
						// 无需提示，检查接口已创建下载任务，直接提示成功
						this.$confirm('下载任务创建成功，可以在下载任务列表查看', '提示', {
							confirmButtonText: '立即查看',
							cancelButtonText: '稍后再看',
							type: 'success',
							center: true,
							closeOnClickModal: false
						}).then(() => {
							this.$router.push({
								path: '/workbench/downloadList'
							});
						}).catch(() => {
							this.dialogVisible1 = false
							this.downLoading1 = false;
						});
					}
				} catch (err) {
					this.$message({
						message: err.message,
						type: 'error'
					});
					this.downLoading1 = false;
				}
			},
			async doExport1(check = false) {
				// 开始加载
				this.downLoading1 = true;
				try {
					const res = await this.$request({
						url: '/activityFinanceSettle/exportInfo',
						method: 'post',
						data: {
							...this.params,
							check: check
						}
					});
					const {
						state,
						msg,
						result
					} = res.data;
					if (state != 1) {
						this.$message.error(msg || '导出失败');
						this.downLoading1 = false;
						this.dialogVisible1 = false;
						return;
					}
					// 任务创建成功
					this.$confirm('下载任务创建成功，可以在下载任务列表查看', '提示', {
						confirmButtonText: '立即查看',
						cancelButtonText: '稍后再看',
						type: 'success',
						center: true,
						closeOnClickModal: false
					}).then(() => {
						this.$router.push({
							path: '/workbench/downloadList'
						});
					}).catch(() => {
						this.dialogVisible1 = false
						this.downLoading1 = false;
					});
				} catch (err) {
					this.$message.error(err.message || '请求错误');
					this.downLoading1 = false;
					this.dialogVisible1 = false;
				}
			},
			//导出结款信息
			async download2() {
				// let filePath;
				this.downLoading2 = true;
				try {
					const res = await this.$request({
						url: '/activityFinanceSettle/exportReceivables',
						method: 'post',
						data: {
							...this.params,
							check: true
						}
					})
					const {
						state,
						msg,
						result
					} = res.data;
					if (state != 1) {
						this.$message.error(msg || '导出失败');
						this.downLoading2 = false;
						return;
					}
					if (result.needTips == true) {
						this.downloadTips2 = result.tips
						this.dialogVisible2 = true
					} else {
						// 无需提示，检查接口已创建下载任务，直接提示成功
						this.$confirm('下载任务创建成功，可以在下载任务列表查看', '提示', {
							confirmButtonText: '立即查看',
							cancelButtonText: '稍后再看',
							type: 'success',
							center: true,
							closeOnClickModal: false
						}).then(() => {
							this.$router.push({
								path: '/workbench/downloadList'
							});
						}).catch(() => {
							this.dialogVisible2 = false
							this.downLoading2 = false;
						});
					}
				} catch (err) {
					this.$message({
						message: err.message,
						type: 'error'
					});
					this.downLoading2 = false;
				}
			},
			async doExport2(check = false) {
				// 开始加载
				this.downLoading2 = true;
				try {
					const res = await this.$request({
						url: '/activityFinanceSettle/exportReceivables',
						method: 'post',
						data: {
							...this.params,
							check: check
						}
					});
					const {
						state,
						msg,
						result
					} = res.data;
					if (state != 1) {
						this.$message.error(msg || '导出失败');
						this.downLoading2 = false;
						this.dialogVisible2 = false;
						return;
					}
					// 任务创建成功
					this.$confirm('下载任务创建成功，可以在下载任务列表查看', '提示', {
						confirmButtonText: '立即查看',
						cancelButtonText: '稍后再看',
						type: 'success',
						center: true,
						closeOnClickModal: false
					}).then(() => {
						this.$router.push({
							path: '/workbench/downloadList'
						});
					}).catch(() => {
						this.dialogVisible2 = false
						this.downLoading2 = false;
					});
				} catch (err) {
					this.$message.error(err.message || '请求错误');
					this.downLoading2 = false;
					this.dialogVisible2 = false;
				}
			},
			copy1() {
				clearTimeout(this.copyTimer1);
				this.copyTimer1 = setTimeout(() => {
					const e = this.$refs.copyTool1;
					e.select();
					document.execCommand("Copy"); // 执行浏览器复制命令
					this.$message.success("内容已复制，可粘贴");
					this.downLoading1 = false
				}, 300)
			},
			copy2() {
				clearTimeout(this.copyTimer2);
				this.copyTimer2 = setTimeout(() => {
					const e = this.$refs.copyTool2;
					e.select();
					document.execCommand("Copy"); // 执行浏览器复制命令
					this.$message.success("内容已复制，可粘贴");
					this.downLoading2 = false
				}, 300)
			},
			view(data) {
				this.$refs.viewDetail.show(data);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.popover-content {
		text-align: center;

		b {
			font-size: 18px;
		}

		p.color-info {
			font-size: 12px;
		}
	}

	.hand {
		cursor: pointer;
	}

	.ML5 {
		margin-left: 5px;
	}

	.tips-main {
		height: 300px;
		overflow-y: auto;
	}

	/* 卡片容器 */
	.tip-card {
		margin-bottom: 16px;
	}

	.tip-card:last-child {
		margin-bottom: 0;
	}

	/* 头部 – 直接显示完整 key */
	.tip-header {
		font-weight: 700;
		color: #1a2332;
		margin-bottom: 10px;
		word-break: break-word;
	}

	/* 列表样式 */
	.tip-list {
		list-style: none;
		margin: 0;
	}

	.tip-list li {
		padding: 6px 0;
		font-size: 14px;
		color: #3d4a5c;
		word-break: break-all;
	}

	.tip-list li:last-child {
		border-bottom: none;
	}

	.copyTool {
		opacity: 0;
		filter: alpha(opacity=0);
		// height: 1px;
	}
</style>